/**
 * SEO fields of `/contact-us` (`pages/contact-us/index.tsx`) and its site-search entry, listed in
 * `scripts/staticSearch.ts`. The `fr` and `es` entries repeat the English.
 */
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";

/** `MetaHead` content of `/contact-us`, by language. */
export const ContactUsMetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Contact Us - Ryerson",
		description: `How can we help? Let us know what you need. Don't forget you can also live chat with a representative.`,
		url: `/contact-us`,
		company: true,
	},
	fr: {
		title: "Contact Us - Ryerson",
		description: `How can we help? Let us know what you need. Don't forget you can also live chat with a representative.`,
		url: `/contact-us`,
		company: true,
	},
	es: {
		title: "Contact Us - Ryerson",
		description: `How can we help? Let us know what you need. Don't forget you can also live chat with a representative.`,
		url: `/contact-us`,
		company: true,
	},
};

/** The page's entry in `public/search-site.json`: its meta only, with no body text. */
export const ContactUsPageContent: StaticPageContent = {
	meta: ContactUsMetaObject,
	content: [],
};
